/* tslint:disable */
/* eslint-disable */
/**
 * BS BFF(ダイナミックパッケージ/DP補助金申請) API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface JpCoBenefitoneBsSubsidyDtoAvailableGetResponseV2ScrennDisplayItemListGroupRemainingAmountLabel
 */
export interface JpCoBenefitoneBsSubsidyDtoAvailableGetResponseV2ScrennDisplayItemListGroupRemainingAmountLabel {
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsSubsidyDtoAvailableGetResponseV2ScrennDisplayItemListGroupRemainingAmountLabel
     */
    value?: string;
}

export function JpCoBenefitoneBsSubsidyDtoAvailableGetResponseV2ScrennDisplayItemListGroupRemainingAmountLabelFromJSON(json: any): JpCoBenefitoneBsSubsidyDtoAvailableGetResponseV2ScrennDisplayItemListGroupRemainingAmountLabel {
    return JpCoBenefitoneBsSubsidyDtoAvailableGetResponseV2ScrennDisplayItemListGroupRemainingAmountLabelFromJSONTyped(json, false);
}

export function JpCoBenefitoneBsSubsidyDtoAvailableGetResponseV2ScrennDisplayItemListGroupRemainingAmountLabelFromJSONTyped(json: any, ignoreDiscriminator: boolean): JpCoBenefitoneBsSubsidyDtoAvailableGetResponseV2ScrennDisplayItemListGroupRemainingAmountLabel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'value': !exists(json, 'value') ? undefined : json['value'],
    };
}

export function JpCoBenefitoneBsSubsidyDtoAvailableGetResponseV2ScrennDisplayItemListGroupRemainingAmountLabelToJSON(value?: JpCoBenefitoneBsSubsidyDtoAvailableGetResponseV2ScrennDisplayItemListGroupRemainingAmountLabel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'value': value.value,
    };
}

